/*
  "Choose your store" modal (snippets/store-select-modal.liquid).

  Opens only when the visitor asks for it, via [data-dn-change-store] in the
  footer. There is no first-visit prompt: the page already renders with a
  default store selected, so nothing needs interrupting. The old auto-open —
  and the "dismissed" flag that existed purely to suppress it — are gone.

  Geolocation is requested on click of "Use my location" and nowhere else. A
  denied permission is effectively permanent from the page's point of view, so
  it is never spent without the visitor asking for it. Failure leaves the
  current store alone and says so in the status line.
*/
(function () {
  'use strict';

  var modalEl = document.getElementById('dn-store-select-modal');
  if (!modalEl) return;

  var panelEl = modalEl.querySelector('.dn-ssm__panel');
  var statusEl = modalEl.querySelector('[data-dn-ssm-status]');
  var geoBtn = modalEl.querySelector('[data-dn-ssm-geolocate]');
  var lastFocused = null;
  var scrollBarWidth = 0;

  function setStatus(message) {
    if (statusEl) statusEl.textContent = message || '';
  }

  function focusableElements() {
    return Array.prototype.slice
      .call(panelEl.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var focusable = focusableElements();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      closeModal();
    } else {
      trapFocus(e);
    }
  }

  function openModal() {
    lastFocused = document.activeElement;
    setStatus('');

    scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollBarWidth > 0) {
      document.body.style.paddingRight = scrollBarWidth + 'px';
    }

    modalEl.hidden = false;
    document.addEventListener('keydown', onKeydown);

    var firstOption = panelEl.querySelector('.dn-ssm__option');
    if (firstOption) firstOption.focus();
  }

  function closeModal() {
    modalEl.hidden = true;
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.removeEventListener('keydown', onKeydown);

    // Return focus to whatever opened the dialog rather than dropping it to the
    // top of the document (WCAG 2.4.3).
    if (lastFocused && document.contains(lastFocused)) {
      lastFocused.focus();
    }
    lastFocused = null;
  }

  modalEl.querySelectorAll('[data-dn-ssm-dismiss]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  modalEl.querySelectorAll('[data-dn-ssm-select]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (window.dnSelectStore) window.dnSelectStore(el.getAttribute('data-dn-ssm-select'));
      closeModal();
    });
  });

  // --- Nearest store by coordinates ---

  function toRadians(deg) {
    return (deg * Math.PI) / 180;
  }

  // Haversine, in kilometres. Only ever used to rank four stores against each
  // other, so the unit is irrelevant — the ordering is what matters.
  function distanceBetween(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = toRadians(lat2 - lat1);
    var dLng = toRadians(lng2 - lng1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)));
  }

  function readStores() {
    var dataEl = document.getElementById('dn-store-data');
    if (!dataEl) return [];
    try {
      return JSON.parse(dataEl.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function nearestStore(lat, lng) {
    var best = null;
    var bestDistance = Infinity;

    readStores().forEach(function (store) {
      // A metaobject missing its coordinates must not win by being NaN.
      if (!isFinite(store.lat) || !isFinite(store.lng)) return;
      var d = distanceBetween(lat, lng, Number(store.lat), Number(store.lng));
      if (d < bestDistance) {
        bestDistance = d;
        best = store;
      }
    });

    return best;
  }

  if (geoBtn) {
    if (navigator.geolocation) geoBtn.hidden = false;

    geoBtn.addEventListener('click', function () {
      if (!navigator.geolocation) {
        setStatus("Location isn't available in this browser.");
        return;
      }

      geoBtn.disabled = true;
      setStatus('Finding your nearest store…');

      navigator.geolocation.getCurrentPosition(
        function (position) {
          geoBtn.disabled = false;
          var store = nearestStore(position.coords.latitude, position.coords.longitude);

          if (!store) {
            setStatus('Could not work out your nearest store. Your store is unchanged.');
            return;
          }

          if (window.dnSelectStore) window.dnSelectStore(store.slug);
          closeModal();
        },
        function () {
          // Denied, unavailable or timed out — all the same to the visitor, and
          // in every case the existing selection stands.
          geoBtn.disabled = false;
          setStatus('Could not get your location. Your store is unchanged — pick one above.');
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
      );
    });
  }

  // "Your store: X — Change" control in the footer. It opens the dialog without
  // clearing the current selection, so backing out leaves the store as it was.
  document.querySelectorAll('[data-dn-change-store]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openModal();
    });
  });
})();
